import { render } from "./JaPage.vue?vue&type=template&id=61372b4c&scoped=true"
import script from "./JaPage.vue?vue&type=script&lang=js"
export * from "./JaPage.vue?vue&type=script&lang=js"

import "./JaPage.vue?vue&type=style&index=0&id=61372b4c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61372b4c"]])

export default __exports__